// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Text__bold___YqpMz{font-weight:bold}.Text__cursorPointer___k2LRx{cursor:pointer}`, "",{"version":3,"sources":["webpack://./packages/scouting-ui/lib/Text/Text.scss"],"names":[],"mappings":"AAAA,oBACE,gBAAA,CAEF,6BACE,cAAA","sourcesContent":[".bold {\n  font-weight: bold;\n}\n.cursorPointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bold": `Text__bold___YqpMz`,
	"cursorPointer": `Text__cursorPointer___k2LRx`
};
export default ___CSS_LOADER_EXPORT___;
